import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModalService } from "@ramudden/ui";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class NoInternetInterceptor implements HttpInterceptor {
    private readonly modalService = inject(ModalService);
    private readonly translateService = inject(TranslateService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!navigator.onLine) {
            return throwError(() => this.modalService.error(this.translateService.instant("errors.noInternet")));
        }

        return next.handle(req).pipe(
            catchError((error) => {
                return throwError(() => error);
            }),
        );
    }
}
